import { useEffect, useState } from "react";
import { listSalesDeskDeals } from "./salesDeskDeals";
import {
  salesDeskFulfillmentFromHint,
  salesDeskOrderCustomer,
  salesDeskSaleStatusLabel,
  type SalesDeskOrder,
} from "./salesDeskOrderFilter";

export function useSalesDeskOrders(): {
  orders: SalesDeskOrder[];
  loading: boolean;
  error: string | null;
} {
  const [orders, setOrders] = useState<SalesDeskOrder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await listSalesDeskDeals();
      if (cancelled) return;
      if (!result.ok) {
        setError(result.error);
        setOrders([]);
        setLoading(false);
        return;
      }
      setOrders(
        result.deals.map((deal) => ({
          id: deal.id,
          customer: salesDeskOrderCustomer(deal.displayName, deal.id),
          serial: deal.serial,
          model: deal.productName,
          saleStatus: salesDeskSaleStatusLabel(deal.status),
          fulfillment: salesDeskFulfillmentFromHint(deal.eventHint),
          createdAt: deal.createdAt,
          updatedAt: deal.updatedAt,
          eventHint: deal.eventHint,
        })),
      );
      setError(null);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { orders, loading, error };
}
